export const base_url=process.env.NODE_ENV==='production' ? "" : 'http://localhost:3000/';

export const goodCompany={
	social_networkers : {
			url:`${base_url}images/social-networkers.svg`
	},	
	bloggers_vloggers : {
			url:`${base_url}images/bloggers-vloggers.svg`
	},	
	journalist_authors : {
			url:`${base_url}images/journalist-authors.svg`
	},	
	photographers_videographers : {
			url:`${base_url}images/photographers-videographers.svg`
	},	
	models_artists : {
			url:`${base_url}images/models-artists.svg`
	},	
	businesses_brands : {
			url:`${base_url}images/businesses-brands.svg`
	},	
	influencers_entertainers : {
			url:`${base_url}images/influencers-entertainers.svg`
		
	},	

}